export default __webpack_public_path__ + "arrow-98f054fcdd6b24266789cfb07474d3bb.svg";